import { openBlock as e, createElementBlock as l, createElementVNode as c } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, o = /* @__PURE__ */ c("path", { d: "M17.11 9.994a1.15 1.15 0 1 0 0-2.3 1.15 1.15 0 0 0 0 2.3Zm-2.17 1.51v-.68h3.37v3.99h.97v.65h-4.32v-.63h.89v-3.33h-.91Z" }, null, -1), n = /* @__PURE__ */ c("path", {
  "fill-rule": "evenodd",
  d: "M18.84 5.014c1.48.31 2.9-.22 2.9-.22h-.02l1.02-.4v15.82l-.56.15c-.17.05-1.5.38-2.6.38-.24 0-.47-.01-.67-.05-1.07-.2-1.84-.58-2.52-.92l-.024-.012c-.7-.345-1.316-.648-2.186-.708-.66-.04-1.18.01-1.64.17a1.654 1.654 0 0 1-1.08 0c-.46-.17-.98-.21-1.64-.17-.87.06-1.486.363-2.186.708l-.024.012-.029.015c-.673.336-1.436.718-2.491.905-.2.03-.43.05-.67.05-1.1 0-2.42-.33-2.6-.38l-.56-.15V4.394l1.02.4c.01.01 1.42.53 2.9.22.66-.14 1.11-.4 1.62-.7l.084-.047c.509-.29 1.08-.614 1.886-.813 1.19-.29 2.23-.26 3.24.12 1.01-.38 2.05-.42 3.24-.12.839.207 1.434.551 1.95.848l.02.012.007.004c.507.299.946.557 1.613.696ZM6.96 18.434c.78-.39 1.59-.79 2.77-.87h-.01c.57-.04 1.07-.01 1.53.07V4.894c-.65-.19-1.32-.2-2.12 0-.64.16-1.09.42-1.57.7-.55.32-1.17.68-2.07.87-1.04.23-2.03.14-2.73 0v12.58c.7.14 1.59.26 2.07.17.842-.145 1.44-.44 2.067-.748l.063-.032Zm12.23.78c.48.09 1.37-.03 2.07-.17h-.01V6.474c-.7.13-1.69.22-2.73 0-.9-.19-1.52-.55-2.07-.87-.48-.28-.93-.54-1.57-.7-.8-.2-1.47-.2-2.13 0v12.73c.47-.08.97-.11 1.54-.07 1.18.08 1.99.48 2.77.87.65.32 1.26.62 2.13.78Z",
  "clip-rule": "evenodd"
}, null, -1), h = [
  o,
  n
];
function d(r, s) {
  return e(), l("svg", t, [...h]);
}
const _ = { render: d };
export {
  _ as default,
  d as render
};
